// import Vue from 'vue'
import Vue from 'vue'
import {
  GET_CAPE,
  ADD_CAPE,
  UPDATE_CAPE,
  DELETE_CAPE,
  REQUEST_CAPE,
  ERROR_XHR
} from '../mutation-types'

/**
 *
 * @param dispatch
 * @returns {Promise}
 */
export const getCapes = ({ dispatch }, contactId) => {
  dispatch(REQUEST_CAPE)
  return new Promise((resolve, reject) => {
    Vue.http
      .get('cape/contact/' + contactId)
      .then(
        (response) => {
          dispatch(GET_CAPE, response.json())
          resolve()
        },
        (response) => {
          dispatch(ERROR_XHR, response.json())
          reject()
        })
  })
}

/**
 * Add a new cape
 * @param dispatch
 * @param cape
 */
export const addCape = ({ dispatch }, cape) => {
  dispatch(REQUEST_CAPE)
  Vue.http
    .post('cape', cape)
    .then(
      (response) => {
        let data = JSON.parse(response.data)
        dispatch(ADD_CAPE, data.cape)
      },
      (response) => {
        dispatch(ERROR_XHR, response.json())
      }
    )
}

/**
 * Edit a cape
 *
 * @param dispatch
 * @param oldContact The former cape data
 * @param newContact The new cape data
 */
export const editCape = ({ dispatch }, oldCape, newCape) => {
  dispatch(REQUEST_CAPE)
  Vue.http
    .put('cape/' + newCape.id, newCape)
    .then(
      (response) => {
        dispatch(UPDATE_CAPE, oldCape, newCape)
      },
      (response) => {
        dispatch(ERROR_XHR, response.json())
      }
    )
}

/**
 * Delete a cape
 *
 * @param dispatch
 * @param cape
 */
export const deleteCape = ({ dispatch }, cape) => {
  dispatch(REQUEST_CAPE)
  Vue.http.delete('cape/' + cape.id)
    .then(
      (response) => {
        dispatch(DELETE_CAPE, cape)
      },
      (response) => {
        dispatch(ERROR_XHR, response.json())
      }
    )
}



// WEBPACK FOOTER //
// ./src/vuex/actions/capeActions.js